import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ffe83cda603442e4b96fe14665216c8f@sentry.io/1367781',
    release: process.env.APP_VERSION,
    replaysSessionSampleRate: 0, // Capture Replays only when an error occurs
    replaysOnErrorSampleRate: 1.0,
    /* Sentry v11 collects user info, cookies, headers and bodies by default when
       dataCollection is unset. Keep the restrictive v10 (sendDefaultPii off) baseline. */
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] }
      },
      httpBodies: [],
      urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      graphQL: { document: false, variables: false }
    },
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      }),
      Sentry.globalHandlersIntegration({
        onunhandledrejection: false
      })
    ]
  });
}
